import React from 'react';
import './Pawn.scss';

const Pawn = ({ color, isActive }) => {
    return (
        <div className={`pawn-container ${isActive ? 'active' : ''}`}>
            <svg 
                viewBox="0 0 100 100" 
                className="pawn-svg"
                xmlns="http://www.w3.org/2000/svg"
            >
                {/* Tête du buste avec contour haute visibilité */}
                <circle 
                    cx="50" cy="30" r="18" 
                    fill={color} 
                    stroke={color === '#ffd32a' ? '#1e293b' : 'white'} 
                    strokeWidth="5" 
                />
                
                {/* Corps du buste avec contour haute visibilité */}
                <path 
                    d="M50 55 c -14 0 -26 10 -30 25 c -1 4 2 8 6 8 h 48 c 4 0 7 -4 6 -8 c -4 -15 -16 -25 -30 -25 z" 
                    fill={color} 
                    stroke={color === '#ffd32a' ? '#1e293b' : 'white'} 
                    strokeWidth="5" 
                    strokeLinejoin="round" 
                />
            </svg>
        </div>
    );
};

export default Pawn;